import React, { useEffect, useState, }  from 'react';
import { useSelector,useDispatch } from 'react-redux';
import { GetUrl, GetMaintenanceUrl, CTicksToDateString } from '../Utility.js';
import { useNavigate } from 'react-router-dom';

function TimeTicketUseModal({ isOpen, onClose}) {
    const state = useSelector((state)=>state);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [isTimeTicketUse, setIsTimeTicketUse] = useState(true);
    const [StartLogIndex, setStartLogIndex] = useState(1);
    const [StartIndex, setStartIndex] = useState(1);

    const [TotalCount, setTotalCount] = useState(-1);
    const [LogTotalCount, setLogTotalCount] = useState(-1);

    const [First, setFirst] = useState(true);

    const timeTicketNames = [
        "1시간 이용권",
        "5시간 이용권",
        "10시간 이용권",
        "종일권(24시간)",
    ];

    useEffect(() => {
        if (isOpen && First) {
          RequestUseTicketInventory(1);
          setFirst(false);
        }
      }, [isOpen, First]);

    const Close = () =>{
        onClose();

        setStartIndex(1);
        setStartLogIndex(1);
        setIsTimeTicketUse(true);
        setTotalCount(-1);
        setLogTotalCount(-1);
        dispatch({type:'UpdateTimeTicketBuyModalInventory', Log:[]});  
        dispatch({type:'UpdateTimeTicketBuyModalLog', Log:[]});  
        setFirst(true);
    }

    function LogStartIndexClick(index)
    {
        if(StartLogIndex === index)
        {
            return;
        }

        if(LogTotalCount === -1)
        {
            return;
        }
    
        var convertIndex = Math.ceil(LogTotalCount / 10);
        if(convertIndex < index)
        {
            return;
        }

        setStartLogIndex(index);
        RequestUseTicketLog(index);
    }
    

    function StartIndexClick(index)
    {
        if(StartIndex === index)
        {
            return;
        }

        if(TotalCount === -1)
        {
            return;
        }

        var convertIndex = Math.ceil(TotalCount / 10);
        if(convertIndex < index)
        {
            return;
        }

        setStartIndex(index);
        RequestUseTicketInventory(index);
    }

    function GetLogNumber(index)
    {
        if(state.time_ticket_use_log_array.length === 0)
        {
            return'';
        }

        var convertIndex = ((StartLogIndex - 1) * 10) + index;
        if(LogTotalCount <= convertIndex)
        {
            return'';
        }

        return convertIndex + 1;
    }

    function GetLogTime(index)
    {
        if(state.time_ticket_use_log_array === undefined || state.time_ticket_use_log_array.length <= index)
        {
            return'';
        }

        return CTicksToDateString(state.time_ticket_use_log_array[index].use_time_ticks);
    }

    function GetLogTicketName(index)
    {
        if(state.time_ticket_use_log_array === undefined || state.time_ticket_use_log_array.length <= index)
        {
            return'';
        }

        return timeTicketNames[state.time_ticket_use_log_array[index].ticket_no - 1];

        //return '1시간 사용권';
    }

    function GetBuyNumber(index)
    {
        if(state.time_ticket_array.length === 0)
        {
            return'';
        }

        var convertIndex = ((StartIndex - 1) * 10) + index;
        if(TotalCount <= convertIndex)
        {
            return'';
        }

        return convertIndex + 1;
    }


    function GetTicketName(index)
    {
        if(state.time_ticket_array.length === undefined || state.time_ticket_array.length <= index)
        {
            return '';
        }

        return timeTicketNames[state.time_ticket_array[index].ticket_no - 1];

        //return '1시간 사용권';
    }

    const UseTicket = async (index) => 
        {
            try
            {
                if(state.time_ticket_array.length <= index)
                {
                    return;
                }

                if(state.Request === 1)
                {
                    return;
                }
    
                var secretkey = sessionStorage.getItem("secret_key");
                if(secretkey === null)
                {
                  alert('유저 정보 만료(다시 로그인 해주세요)');  
                  navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                  return;    
                }
                
                dispatch({type:'Request'});
                const response = await fetch(GetUrl() + 'UseTimeTicket/UseTimeTicket', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ secret_key : secretkey, inventory_no : state.time_ticket_array[index].sn}),
                });
    
                if (response.ok) {
                    const data = await response.json();
                    if(data.result === 0)
                    {
                        alert(timeTicketNames[state.time_ticket_array[index].ticket_no - 1] + ' 사용 성공');
                        dispatch({type:'UpdateRemainTime', RemainTime:data.remain_time});  
                        dispatch({type:'UpdateTimeTicketBuyModalInventory', Log:[]});  
                        if(StartIndex === 1)
                        {
                            RequestUseTicketInventory(1);    
                        }   
                        else
                        {
                            StartIndexClick(1);
                        }  
                    }
                    else if(data.result === 14 ||
                            data.result === 16)
                    {
                        alert('존재 하지 않는 티켓 입니다');  
                    }
                    else if(data.result === 15)
                    {
                        alert('이미 사용한 티켓 입니다');  
                    }
                    else if(data.result === 3 ||
                            data.result === 1)
                    {
                        alert('유저 정보 만료(다시 로그인 해주세요)');  
                        navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                    else if(data.result === 21) // 점검 중
                    {
                      var startTime = CTicksToDateString(data.start_time);
                      var endTime = CTicksToDateString(data.end_time);
        
                      var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                      alert(message);  
                      navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                } 
                else
                {
                    alert('Network Fail');
                }
    
                dispatch({type:'Response'});
            }
            catch(error)
            {
                alert('Network Fail');
                dispatch({type:'Response'});
                console.error(error);
            }
        };

    function GetUseTicketIndex(index)
    {
        if(state.time_ticket_array.length === undefined || state.time_ticket_array.length <= index)
        {
            return false;
        }

        return true;
    }

    const RequestUseTicketInventory = async (index) => 
        {
            try
            {
                if(state.Request === 1)
                {
                    return;
                }
    
                var secretkey = sessionStorage.getItem("secret_key");
                if(secretkey === null)
                {
                  alert('유저 정보 만료(다시 로그인 해주세요)');  
                  navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                  return;    
                }
                
                dispatch({type:'Request'});
                const response = await fetch(GetUrl() + 'SearchInventory/SearchInventory', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ secret_key : secretkey, start_index : index - 1, content_count : 10}),
                });
    
                if (response.ok) {
                    const data = await response.json();
                    if(data.result === 0)
                    {
                        dispatch({type:'UpdateTimeTicketBuyModalInventory', Log:data.data_array});  
                        setTotalCount(data.total_count);
                    }
                    else if(data.result === 14 ||
                            data.result === 16)
                    {
                        alert('존재 하지 않는 티켓 입니다');  
                    }
                    else if(data.result === 15)
                    {
                        alert('이미 사용한 티켓 입니다');  
                    }
                    else if(data.result === 3 ||
                            data.result === 1)
                    {
                        alert('유저 정보 만료(다시 로그인 해주세요)');  
                        navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                    else if(data.result === 21) // 점검 중
                    {
                      var startTime = CTicksToDateString(data.start_time);
                      var endTime = CTicksToDateString(data.end_time);
        
                      var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                      alert(message);  
                      navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                } 
                else
                {
                    alert('Network Fail');
                }
    
                dispatch({type:'Response'});
            }
            catch(error)
            {
                alert('Network Fail');
                dispatch({type:'Response'});
                console.error(error);
            }
        };

        const RequestUseTicketLog = async (index) => 
            {
                try
                {
                    if(state.Request === 1)
                    {
                        return;
                    }
        
                    var secretkey = sessionStorage.getItem("secret_key");
                    if(secretkey === null)
                    {
                      alert('유저 정보 만료(다시 로그인 해주세요)');  
                      navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                      return;    
                    } 
                    
                    dispatch({type:'Request'});
                    const response = await fetch(GetUrl() + 'SearchUseTicket/SearchUseTicket', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ secret_key : secretkey, start_index : index - 1, content_count : 10}),
                    });
        
                    if (response.ok) {
                        const data = await response.json();
                        if(data.result === 0)
                        {
                            dispatch({type:'UpdateTimeTicketBuyModalLog', Log:data.data_array});  
                            setLogTotalCount(data.total_count);
                        }
                        else if(data.result === 14 ||
                                data.result === 16)
                        {
                            alert('존재 하지 않는 티켓 입니다');  
                        }
                        else if(data.result === 15)
                        {
                            alert('이미 사용한 티켓 입니다');  
                        }
                        else if(data.result === 3 ||
                                data.result === 1)
                        {
                            alert('유저 정보 만료(다시 로그인 해주세요)');  
                            navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                        }
                        else if(data.result === 21) // 점검 중
                        {
                          var startTime = CTicksToDateString(data.start_time);
                          var endTime = CTicksToDateString(data.end_time);
            
                          var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                          alert(message);  
                          navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                        }
                    } 
                    else
                    {
                        alert('Network Fail');
                    }
        
                    dispatch({type:'Response'});
                }
                catch(error)
                {
                    alert('Network Fail');
                    dispatch({type:'Response'});
                    console.error(error);
                }
            };

        function ChangeView(view)
        {
            if(isTimeTicketUse === view)
            {
                return;
            }
    
            setIsTimeTicketUse(view);
            if(view === false)
            {
                setStartIndex(1);
                setStartLogIndex(1);
                setTotalCount(-1);
                setLogTotalCount(-1);
                dispatch({type:'UpdateTimeTicketBuyModalInventory', Log:[]});  
                dispatch({type:'UpdateTimeTicketBuyModalLog', Log:[]});  
                RequestUseTicketLog(1);
            }
            else
            {
                setStartIndex(1);
                setStartLogIndex(1);
                setTotalCount(-1);
                setLogTotalCount(-1);
                dispatch({type:'UpdateTimeTicketBuyModalInventory', Log:[]});  
                dispatch({type:'UpdateTimeTicketBuyModalLog', Log:[]});  
                RequestUseTicketInventory(1);
            }
        }

    if (!isOpen) return null;

    //if(First === true)
    //{
    //    RequestUseTicketInventory(1);
    //    setFirst(false);
    //}

    return (
        <div className="time-ticket-use-modal-overlay" onClick={Close}>
            <div className='time-ticket-use-modal-button-box' onClick={(e) => e.stopPropagation()}>
                <div className="time-ticket-use-modal" style={{backgroundColor: isTimeTicketUse === true ? "RGB(255,255,255)" : "RGB(143,143,143)"}} onClick={() => ChangeView(true)}><h2>시간권 사용</h2></div>
                <div className="time-ticket-use-log-modal" style={{backgroundColor: isTimeTicketUse === true ? "RGB(143,143,143)" : "RGB(255,255,255)"}} onClick={() => ChangeView(false)}><h2>사용 내역</h2></div>
                <button className="time-ticket-use-modal-close" onClick={Close}>
                    <h2>X</h2>
                </button>
            </div>
            <div className="time-ticket-use-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className='time-ticket-use-box' style={{ display: isTimeTicketUse ? 'block' : 'none' }}>
                       <div className='time-ticket-use-box-table'>
                        <table>
                        <thead>
                            <tr>
                                <th className='table-number'>넘버</th>
                                <th className='table-name'>티켓 이름</th>
                                <th className='table-use'>사용하기</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.from({length:10}).map((_, index)=>(
                                <tr key={index}>
                                    <td style={{textAlign:"center"}}>{GetBuyNumber(index)}</td>
                                    <td style={{textAlign:"center"}}>{GetTicketName(index)}</td>
                                    {GetUseTicketIndex(index) === true && <td style={{textAlign:"center"}} onClick={() => UseTicket(index)}><div className='time-ticket-use-box-button'>사용하기</div></td>}
                                    {GetUseTicketIndex(index) === false && <td style={{textAlign:"center"}}></td>}
                                </tr>
                            ))}
                        </tbody>
                        </table>
                    </div>
                    <div className='time-ticket-use-count-box'>
                        <div className='time-ticket-use-count' onClick={() => StartIndexClick(1)}><h2 style={{fontWeight: StartIndex === 1 ? "bold" : "normal"}}>1</h2></div>
                        <div className='time-ticket-use-count' onClick={() => StartIndexClick(2)}><h2 style={{fontWeight: StartIndex === 2 ? "bold" : "normal"}}>2</h2></div>
                        <div className='time-ticket-use-count' onClick={() => StartIndexClick(3)}><h2 style={{fontWeight: StartIndex === 3 ? "bold" : "normal"}}>3</h2></div>
                        <div className='time-ticket-use-count' onClick={() => StartIndexClick(4)}><h2 style={{fontWeight: StartIndex === 4 ? "bold" : "normal"}}>4</h2></div>
                        <div className='time-ticket-use-count' onClick={() => StartIndexClick(5)}><h2 style={{fontWeight: StartIndex === 5 ? "bold" : "normal"}}>5</h2></div>
                        <div className='time-ticket-use-count' onClick={() => StartIndexClick(6)}><h2 style={{fontWeight: StartIndex === 6 ? "bold" : "normal"}}>6</h2></div>
                        <div className='time-ticket-use-count' onClick={() => StartIndexClick(7)}><h2 style={{fontWeight: StartIndex === 7 ? "bold" : "normal"}}>7</h2></div>
                        <div className='time-ticket-use-count' onClick={() => StartIndexClick(8)}><h2 style={{fontWeight: StartIndex === 8 ? "bold" : "normal"}}>8</h2></div>
                        <div className='time-ticket-use-count' onClick={() => StartIndexClick(9)}><h2 style={{fontWeight: StartIndex === 9 ? "bold" : "normal"}}>9</h2></div>
                        <div className='time-ticket-use-count' onClick={() => StartIndexClick(10)}><h2 style={{fontWeight: StartIndex === 10 ? "bold" : "normal"}}>10</h2></div>
                    </div>
                </div>
                <div className='time-ticket-use-log-box' style={{ display: isTimeTicketUse ? 'none' : 'block'   }}>
                    <div className='time-ticket-use-log-box-table'>
                    <table>
                        <thead>
                            <tr>
                                <th className='table-number'>넘버</th>
                                <th className='table-name'>사용 일시</th>
                                <th className='table-use'>티켓 이름</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.from({length:10}).map((_, index)=>(
                                <tr key={index}>
                                    <td style={{textAlign:"center"}}>{GetLogNumber(index)}</td>
                                    <td style={{textAlign:"center"}}>{GetLogTime(index)}</td>
                                    <td style={{textAlign:"center"}}>{GetLogTicketName(index)}</td>
                                </tr>
                            ))}
                        </tbody>
                        </table>
                    </div>
                    <div className='time-ticket-use-log-count-box'>
                        <div className='time-ticket-use-log-count' onClick={() => LogStartIndexClick(1)}><h2 style={{fontWeight: StartLogIndex === 1 ? "bold" : "normal"}}>1</h2></div>
                        <div className='time-ticket-use-log-count' onClick={() => LogStartIndexClick(2)}><h2 style={{fontWeight: StartLogIndex === 2 ? "bold" : "normal"}}>2</h2></div>
                        <div className='time-ticket-use-log-count' onClick={() => LogStartIndexClick(3)}><h2 style={{fontWeight: StartLogIndex === 3 ? "bold" : "normal"}}>3</h2></div>
                        <div className='time-ticket-use-log-count' onClick={() => LogStartIndexClick(4)}><h2 style={{fontWeight: StartLogIndex === 4 ? "bold" : "normal"}}>4</h2></div>
                        <div className='time-ticket-use-log-count' onClick={() => LogStartIndexClick(5)}><h2 style={{fontWeight: StartLogIndex === 5 ? "bold" : "normal"}}>5</h2></div>
                        <div className='time-ticket-use-log-count' onClick={() => LogStartIndexClick(6)}><h2 style={{fontWeight: StartLogIndex === 6 ? "bold" : "normal"}}>6</h2></div>
                        <div className='time-ticket-use-log-count' onClick={() => LogStartIndexClick(7)}><h2 style={{fontWeight: StartLogIndex === 7 ? "bold" : "normal"}}>7</h2></div>
                        <div className='time-ticket-use-log-count' onClick={() => LogStartIndexClick(8)}><h2 style={{fontWeight: StartLogIndex === 8 ? "bold" : "normal"}}>8</h2></div>
                        <div className='time-ticket-use-log-count' onClick={() => LogStartIndexClick(9)}><h2 style={{fontWeight: StartLogIndex === 9 ? "bold" : "normal"}}>9</h2></div>
                        <div className='time-ticket-use-log-count' onClick={() => LogStartIndexClick(10)}><h2 style={{fontWeight: StartLogIndex === 10 ? "bold" : "normal"}}>10</h2></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TimeTicketUseModal;